import { render, staticRenderFns } from "./media-uploader.vue?vue&type=template&id=3956cd6e&scoped=true&"
import script from "./media-uploader.vue?vue&type=script&lang=js&"
export * from "./media-uploader.vue?vue&type=script&lang=js&"
import style0 from "./media-uploader.vue?vue&type=style&index=0&id=3956cd6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956cd6e",
  null
  
)

export default component.exports